import { render, staticRenderFns } from "./ModalPlanosIncluir.vue?vue&type=template&id=205e785e&scoped=true"
import script from "./ModalPlanosIncluir.vue?vue&type=script&lang=ts"
export * from "./ModalPlanosIncluir.vue?vue&type=script&lang=ts"
import style0 from "./ModalPlanosIncluir.vue?vue&type=style&index=0&id=205e785e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205e785e",
  null
  
)

export default component.exports